<template>
  <div class="w-full bg-white flex flex-col border-blue-800 border-8">

      <ring-loader v-if="showLoader"></ring-loader>



    <div v-for="(image, i) in classImages" :key="i">

        <div class="flex justify-center items-center mt-10 mb-10 w-full px-2 lg:pl-20">
            
            <label class="mr-1 lg:mr-5"><strong>{{$t('sessions.imageNumber')}}i: </strong></label>

            <img :src="image[i]" class="mg-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="profileImageRef" width="100"/>

        </div>
    </div> 


    <div class="mt-64 w-full flex justify-center">
        <button 
        class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
        v-on:click="closeClassPage">{{$t('profile.close')}}</button>
    </div>

    <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('classes.className')}} </strong></label>

            
            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.name}}</label>
    </div>


    <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('classes.instructorName')}} </strong></label>

            
            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.instructor_name}}</label>
    </div>

    <div v-if="myClass.pay_cash" class="flex justify-center items-center mt-10 mb-10 w-full">
                    
            <label class="mr-5"><strong>{{$t('classes.cash')}} </strong></label>

            
            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.cash_cost}}</label>
    </div>

    <div v-if="myClass.pay_points" class="flex justify-center items-center mt-10 mb-10 w-full">
                    
            <label class="mr-5"><strong>{{$t('classes.points')}} </strong></label>

            
            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.points_cost}}</label>
    </div>

    <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('classes.level')}} </strong></label>

            
            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.level}}</label>
      </div>


    <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('classes.type')}} </strong></label>

            <label
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{type}}</label>
    </div>

     <div class="flex flex-wrap justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('classes.description')}} </strong></label>

            <p
            class="mr-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{myClass.description}}</p>
    </div>

    <div v-if="showBusiness == false && showInstructor == false">
        <button 
        class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
         v-on:click="showBusiness = true">

            {{$t('sessions.showBusiness')}}

        </button>
    </div>

    <div v-if="showBusiness == false && showInstructor == false">
        <button 
        class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
         v-on:click="showInstructor = true">

            {{$t('sessions.showInstructor')}}
        </button>
    </div>

    <div v-if="showBusiness == true && showInstructor == false">
        
        <div>
        <button 
        class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
         v-on:click="showBusiness = false">{{$t('profile.close')}}</button>
        </div>
        
        <div class="w-full h-full">

            <class-business :businessId="myClass.business.id" :userId="userId"></class-business>
        </div>
    </div>

    <div v-if="showBusiness == false && showInstructor == true">

        <div>
            <button 
            class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
            hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
            v-on:click="showInstructor = false">{{$t('profile.close')}}</button>
        </div>

        <div class="w-full h-full">

            <class-instructor :instructorId="myClass.instructor.id" :userId="userId"></class-instructor>
        </div>
    </div>
  </div>
</template>

<script>

// import dropzone from "vue2-dropzone";
// import 'vue2-dropzone/dist/vue2Dropzone.css'
// import uploadImage from 'vue-upload-image';

import firebase from '../classes/firebase';

import ClassBusiness from './ClassBusiness';

import ClassInstructor from './ClassInstructor'

import componentsHelpers from '../classes/componentHelpers';

export default {

  created()
  {

    // console.log(`myClass: ${JSON.stringify(this.myClass)}`);
  },

  props: {

    closeClassPage: {

        type: Function 
    },

    tokenId: '',

    userId:0,

    myClass:{
      
      type: Object,
      default: () => ({})
    },
  },
  components: {

    ClassBusiness, 
    ClassInstructor
  },

  mounted(){

        // console.log(`in class page`);
        // console.log(`class: ${JSON.stringify(this.myClass)}`);
      try{

           if(this.myClass.image_1 != null && this.myClass.image_1 != ''){

            this.classImages.push(this.myClass.image_1);

            if(this.myClass.image_2 != null && this.myClass.image_2 != ''){

                this.classImages.push(this.myClass.image_2);
                
                if(this.myClass.image_3 != null && this.myClass.image_3 != ''){

                    this.classImages.push(this.myClass.image_3);

                    if(this.myClass.image_4 != null && this.myClass.image_4 != ''){

                        this.classImages.push(this.myClass.image_4);

                        if(this.myClass.image_5 != null && this.myClass.image_5 != ''){

                            this.classImages.push(this.myClass.image_5);

                            if(this.myClass.image_6 != null && this.myClass.image_6 != ''){

                                this.classImages.push(this.myClass.image_6);

                                if(this.myClass.image_7 != null && this.myClass.image_7 != ''){

                                    this.classImages.push(this.myClass.image_7);

                                    if(this.myClass.image_8 != null && this.myClass.image_8 != ''){

                                        this.classImages.push(this.myClass.image_8);
                                    }
                                }
                            }
                        }
                    }
                }
            } 
        }

        this.setType();

      }catch(error){

        componentsHelpers.sendError(this.$apollo, this.userId,'Sessions', 'classPage', 'mounted - catch 1', error);

        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
      }
    },

  methods: {

      setType(){
            
            const types = this.myClass.categories;

            for(let i = 0; i < types.length; i++){

                if(i != types.length - 1){
                    
                    this.type = this.type + types[i].category.name + ', '
                }
                else {
                  
                  this.type = this.type + types[i].category.name;
                }
            }

            return this.type;
        },  
  },

  data: function() {

    return {

        classImages: [],

        type: '',
        showBusiness: false,
        showInstructor: false,
    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>